import { styled } from "@mui/material/styles";

export default styled("div")(({ theme }) => ({
  padding: theme.spacing(4),
  marginBottom: theme.spacing(2),
  backgroundColor: "#F7F7F7",
  borderRadius: "0.25rem",
  border: "0.0125rem solid #dbdbdb",
}));
